import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00a7d21c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "b-step1-detail-wrapper" }
const _hoisted_2 = { class: "item text-overflow" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "所属大区：", -1))
const _hoisted_4 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "调动人员：", -1))
const _hoisted_6 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "考勤截止日期：", -1))

import {
  ref,
  reactive,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import { getEmployeeTransferApply } from "@/api/process_employeeTransfer";

export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean }





watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getdata();
    }
  }
);

const list = ref<
  { RegionName?: string; TransferStaffName?: string; SignInLastDate?: string }[]
>([]);

onMounted(async () => {
  getdata();
});
const getdata = async () => {
  const { Data } = await getEmployeeTransferApply({
    BranchCompanyFlowId: props.folwId,
  });
  list.value = (Data?.PageData && Data?.PageData) || [];
  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (list.value.length > 0)
      ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", null, _toDisplayString(list.value[0].RegionName), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
      return (_openBlock(), _createBlock(_component_a_row, { key: index }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(item.TransferStaffName), 1)
          ]),
          _createElementVNode("span", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(item.SignInLastDate?.split(" ")[0]), 1)
          ])
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}
}

})